export default "__VITE_PUBLIC_ASSET__bce40561__"